export default __webpack_public_path__ + "static/media/loadingGif.e1658f1b.gif";